module.exports = __webpack_public_path__ + "img/web-P4-3-3.4297e663.svg";